import * as Yup from "yup";

export const schema = Yup.object().shape({
  email: Yup.string()
    .required("Ingresa tu corréo electrónico")
    .email("El email no es válido.")
    .trim("El corréo electrónico no puede contener espacio")
    .max(200, "no puede superar los 200 caracteres"),
  name: Yup.string()
    .required("Ingresa tu nombre"),
  phone_number: Yup.string().when('$askForPhone', {
    is: true,
    then: (schema) => schema.required("Ingresa tu número de teléfono"),
    otherwise: (schema) => schema.optional(),
  }),
  phone_area_code: Yup.string().when('$askForPhone', {
    is: true,
    then: (schema) => schema.required("Selecciona el código de país"),
    otherwise: (schema) => schema.optional(),
  }),
  terminosCondiciones: Yup.array()
    .of(Yup.string())
    .min(1, "Debes aceptar las condiciones."),
});

interface FormValues {
  email: string;
  name: string;
  phone_number?: string;
  phone_area_code?: string;
  terminosCondiciones: string[];
}

export const initialValues: FormValues = {
  email: "",
  name: "",
  phone_number: "",
  phone_area_code: "",
  terminosCondiciones: ["true"],
};
